module.exports = __webpack_public_path__ + "static/img/DE.11f442a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/DE.svg
// module id = 930
// module chunks = 0